<template>
  <div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row d-flex justify-content-lg-center">
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="date"
                        >Date <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date"
                        name="date"
                        placeholder="Date"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="date_reception"
                        >Date de réception souhaitée
                        <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_reception"
                        name="date_reception"
                        placeholder="Date de réception"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_reception'),
                        }"
                        type="hidden"
                      />
                      <has-error
                        :form="form"
                        field="date_reception"
                      ></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-3">
                    <div class="form-group">
                      <label for="fournisseur"
                        >Fournisseur <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="fournisseurs"
                        :reduce="(fournisseur) => fournisseur.uuid"
                        v-model="form.fournisseur"
                        placeholder="Fournisseur"
                        @input="onChangeFournisseur"
                      >
                        <template
                          v-slot:option="{ nom, telephone, email, devise }"
                        >
                          <h5 style="margin: 0">{{ nom }}</h5>
                          <span class="d-block" v-if="devise">
                            Devise : {{ devise.symbole }}
                          </span>
                          <span class="d-block" v-if="telephone">
                            Téléphone : {{ telephone }}
                          </span>
                          <span class="d-block" v-if="email">
                            Email : {{ email }}
                          </span>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="fournisseur"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('fournisseur'),
                          }"
                        />
                        <has-error :form="form" field="fournisseur"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="devise"
                        >Devise <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="symbole"
                        :options="devises"
                        :reduce="(devise) => devise.uuid"
                        v-model="form.devise"
                        placeholder="Devise"
                      >
                        <template v-slot:option="{ symbole }">
                          <h5 style="margin: 0">{{ symbole }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="devise"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('devise'),
                          }"
                        />
                        <has-error :form="form" field="devise"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="centre_cout"
                        >Centre de coût
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="centreCouts"
                        :reduce="(centreCout) => centreCout.uuid"
                        v-model="form.centre_cout"
                        placeholder="Centre de coût"
                        @input="onChangeCentreCout"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="centre_cout"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('centre_cout'),
                          }"
                        />
                        <has-error :form="form" field="centre_cout"></has-error>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-n4">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mt-n2 mb-n2">
                <div class="row mt-n2 d-flex justify-content-center">
                  <div class="col-md-8 col-lg-6">
                    <cool-select
                      v-model="selectedArticle"
                      :items="articles"
                      item-text="designation"
                      placeholder="Recherche article"
                      disable-filtering-by-search
                      @search="onSearchArticle"
                      @select="onSelectedArticle"
                      :search-text.sync="searchText"
                    >
                      <template #no-data>
                        {{
                          noData
                            ? 'Aucun resultat.'
                            : '2 caratères pour lancer la recherche.'
                        }}
                      </template>
                      <template #item="{ item }">
                        <div class="item">
                          <div>
                            <h5>{{ item.designation }}</h5>
                            <span v-if="item.reference" class="d-block">
                              Référence : {{ item.reference }}
                            </span>
                            <span v-if="item.unite" class="d-block">
                              Unité : {{ item.unite }}
                            </span>
                            <span v-if="item.article_type" class="d-block">
                              Type d'article :
                              {{
                                item.article_type === 'produits'
                                  ? 'Produit'
                                  : 'Service'
                              }}
                            </span>
                          </div>
                        </div>
                      </template>
                    </cool-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-alert
          :show="itemListErrorMessage !== null"
          dismissible
          variant="danger"
        >
          <span v-html="itemListErrorMessage"></span>
        </b-alert>
        <div class="row mt-n4">
          <div class="col-md-12">
            <table class="card table table-sm">
              <thead>
                <tr class="d-flex">
                  <th class="col-3">Article</th>
                  <th class="col-2 text-center">Quantité</th>
                  <th class="col-1 text-center">Prix HT</th>
                  <th class="col-1 text-center">TVA %</th>
                  <th class="col-2 text-center">
                    Budget
                    <span v-if="getCurrency()">
                      ({{ getCurrency().symbole }})
                    </span>
                  </th>
                  <th class="col-2 text-center">Montant</th>
                  <th class="col-1 text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in form.item_lists"
                  :key="index"
                  class="d-flex"
                >
                  <td class="col-3" style="vertical-align: middle">
                    Désignation : {{ item.designation }} <br />
                    Référence : {{ item.reference }} <br />
                    Stock :
                    {{
                      item.stock !== '-'
                        ? item.stock + ' ' + item.unite
                        : item.stock
                    }}
                  </td>
                  <td class="col-2 text-center" style="vertical-align: middle">
                    <div class="input-group">
                      <input
                        class="form-control"
                        v-model="item.quantite"
                        type="text"
                        placeholder="Quantité"
                        @focus="$event.target.select()"
                      />
                      <div class="input-group-append bg-transparent">
                        <span class="input-group-text bg-transprent">
                          {{ item.unite }}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td class="col-1 text-center" style="vertical-align: middle">
                    <input
                      class="form-control"
                      v-model="item.prix"
                      type="text"
                      placeholder="Prix HT"
                      @focus="$event.target.select()"
                    />
                  </td>

                  <td class="col-1 text-center" style="vertical-align: middle">
                    <input
                      class="form-control"
                      v-model="item.tva"
                      type="text"
                      placeholder="TVA %"
                      @focus="$event.target.select()"
                    />
                  </td>
                  <td class="col-2 text-center" style="vertical-align: middle">
                    <progress-bar
                      v-if="item.etat !== null"
                      bar-color="#dc720f"
                      :val="item.consommation"
                      :max="100"
                      :text="item.etat"
                      size="medium"
                    />
                    <span v-else> ### </span>
                  </td>
                  <td
                    class="col-2 text-right font-weight-bold font-size-17"
                    style="vertical-align: middle"
                  >
                    {{
                      formatWithCurrency(
                        item.quantite * item.prix +
                          (item.tva / 100) * (item.quantite * item.prix),
                        symbole
                      )
                    }}
                  </td>
                  <td class="col-1 text-center" style="vertical-align: middle">
                    <a
                      class="cursor-pointer"
                      @click.prevent="removeItem(index)"
                    >
                      <i class="fa fa-trash font-size-17 text-danger"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="form.item_lists.length === 0" class="d-flex">
                  <td colspan="7" class="text-center col-12">Aucune donnée</td>
                </tr>
              </tbody>
              <tfoot class="font-weight-bold font-size-18">
                <tr class="d-flex">
                  <td class="text-right col-8">TOTAL HT</td>
                  <td class="text-right col-4">
                    {{ formatWithCurrency(totalHt, symbole) }}
                  </td>
                </tr>
                <tr class="d-flex" v-if="totalTva > 0">
                  <td class="text-right col-8">TOTAL TVA</td>
                  <td class="text-right col-4">
                    {{ formatWithCurrency(totalTva, symbole) }}
                  </td>
                </tr>
                <tr class="d-flex" v-if="totalTva > 0">
                  <td class="text-right col-8">TOTAL TTC</td>
                  <td class="text-right col-4">
                    {{ formatWithCurrency(totalHt + totalTva, symbole) }}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL_DMD from '@/http/achat/demande';
import URL_ARTICLE from '@/http/article_stock/article';

import Form from 'vform';
import { CoolSelect } from 'vue-cool-select';
import DatePicker from 'vue2-datepicker';
import ProgressBar from 'vue-simple-progress';

export default {
  data() {
    return {
      form: new Form({
        date: '',
        date_reception: '',
        centre_cout: '',
        devise: '',
        fournisseur: '',
        item_lists: [],
      }),
      annee: new Date().getFullYear(),
      devises: [],
      articles: [],
      centreCouts: [],
      fournisseurs: [],
      selectedArticle: null,
      noData: false,
      timeoutId: null,
      searchText: null,
      id: null,

      itemListErrorMessage: null,
    };
  },
  computed: {
    symbole() {
      if (this.form.devise) {
        let obj = window._.find(
          this.devises,
          (d) => d.uuid === this.form.devise
        );
        if (obj) return obj.symbole;
        return this.getCurrency().symbole || '';
      }
      return this.getCurrency().symbole || '';
    },
    totalHt() {
      return window._.sumBy(
        this.form.item_lists,
        (item) => item.quantite * item.prix
      );
    },
    totalTva() {
      return window._.sumBy(
        this.form.item_lists,
        (item) => (item.tva / 100) * (item.quantite * item.prix)
      );
    },
  },
  watch: {
    $route() {
      this.init();
    },
  },
  components: {
    CoolSelect,
    DatePicker,
    ProgressBar,
  },
  methods: {
    onChangeFournisseur() {
      if (this.form.fournisseur) {
        let devise = window._.find(
          this.fournisseurs,
          (t) => t.uuid === this.form.fournisseur
        ).devise;
        if (devise) this.form.devise = devise.uuid;
        this.getPrixArticles(this.form.item_lists, this.form.fournisseur);
      }
    },
    onChangeCentreCout() {
      if (this.form.centre_cout) {
        this.getBudgetArticles(
          this.form.item_lists,
          this.form.centre_cout,
          this.annee
        );
      }
    },
    init() {
      this.centreCouts = [];
      this.fournisseurs = [];
      this.devises = [];
      this.id = this.$route.params.id;

      window.axios
        .all([
          window.axios.get(URL_DMD.GET_REQUIREMENTS),
          window.axios.get(URL_DMD.DEMANDE + '/' + this.id, {
            params: { edit: true },
          }),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.centreCouts = resp1.data.centre_couts;
            this.devises = resp1.data.devises;
            this.fournisseurs = resp1.data.fournisseurs;
            Object.assign(this.form, resp2.data.demande_achat);
            this.annee = resp2.data.demande_achat.annee;
            delete this.form.annee;
            this.getBudgetArticles(
              this.form.item_lists,
              this.form.centre_cout,
              this.annee
            );
          })
        )
        .catch();
    },
    onSelectedArticle: function (select) {
      if (select) {
        var objExiste = window._.find(
          this.form.item_lists,
          (o) => o.article === select.uuid
        );
        if (!objExiste) {
          this.form.item_lists.push({
            id: null,
            article: select.uuid,
            designation: select.designation,
            reference: select.reference,
            unite: select.unite,
            quantite: 1,
            prix: select.catalogue ? select.catalogue.prix : 0,
            tva: select.catalogue ? select.catalogue.tva : 0,
            stock: select.stock,
            consommation: null,
            etat: null,
          });
        } else {
          objExiste.quantite += 1;
        }
        this.getBudgetArticles(
          this.form.item_lists,
          this.form.centre_cout,
          this.annee
        );

        this.searchText = null;
        this.selectedArticle = null;
        this.articles = [];
      }
    },
    async onSearchArticle(search) {
      const lettersLimit = 2;

      this.articles = [];
      this.noData = false;

      if (search.length < lettersLimit || !this.form.fournisseur) {
        return;
      }

      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        await window.axios
          .get(URL_ARTICLE.SEARCH_ARTICLE, {
            params: {
              search: search,
              onlyProduit: false,
              achat: true,
              tiers: this.form.fournisseur,
              sortBy: 'designation',
              sortDesc: false,
            },
          })
          .then((resp) => {
            this.articles = resp.data;
          })
          .catch();

        if (!this.articles.length) {
          this.noData = true;
        } else if (this.articles.length === 1) {
          this.onSelectedArticle(this.articles[0]);
        }
      }, 500);
    },
    removeItem: function (index) {
      this.form.item_lists.splice(index, 1);
      this.getBudgetArticles(
        this.form.item_lists,
        this.form.centre_cout,
        this.annee
      );
    },
    submit() {
      this.form.ids = this.form.item_lists
        .filter((item) => item.id !== null)
        .map((item) => item.id);

      this.itemListErrorMessage = null;
      this.form
        .put(URL_DMD.DEMANDE + '/' + this.id)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.init();
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('item_lists')) {
              this.itemListErrorMessage = value[0];
            } else {
              this.form.errors.set('message', err.response.data.message);
            }
            return 0;
          });
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
